import {isTrue} from 'ramda-adjunct';

import type {UserResponseBody} from '@dms/api/shared';

// A user picker is fetched with `stateFilter: active`, so any user still present
// in the list that reads as inactive is a persisted assignee re-injected by
// `useUsersWithPersistedAssignee`.
// TODO(T20-130265): also return user.deleted

export const isUserInactive = (user: UserResponseBody) => isTrue(user.blocked);
